import { FC, useContext } from "react";


import { RoleRestricted, Roles } from "@app/user";
import MegaMenuHeader from "./MegaMenuHeader";
import MegaMenuStandardLink from "./MegaMenuStandardLink";

import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import MegaMenuLink from "./MegaMenuLink";
import { Features } from "@app/feature-flags";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
const DataMenu: FC = () => {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Data" />
        <ul className="menu">
          {
            featureFlags.has(Features.NEW_PROVIDER_MANAGEMENT_UI) ?
              <MegaMenuLink menuItem={MenuItemEnum.Providers} faIcon="user-md" to={`/provider-sets/manager`} linkText="Providers" />
              : <MegaMenuStandardLink menuItem={MenuItemEnum.Providers} faIcon="user-md" to={`${window.uiEndpoint}/Data/ProviderSets`} linkText="Providers" />
          }
          <MegaMenuLink menuItem={MenuItemEnum.Members} faIcon="users" to={`/member-populations`} linkText="Member Populations" />
          <RoleRestricted allowedRoles={[Roles.CLIENT_ADMIN, Roles.QUEST_ADMIN]}>
            <MegaMenuStandardLink menuItem={MenuItemEnum.Censuses} faIcon="user" to={`${window.uiEndpoint}/Data/Censuses`} linkText="Censuses" />
          </RoleRestricted>
        </ul>
      </li>
    </ul>
  );
}

export default DataMenu;